import {
  ICheckoutCart,
  ICheckoutCartCustomer,
  ICheckoutCartEarlyRenewalContract,
  ICheckoutCartOffer,
} from '@/interfaces/Checkout';
import { IRewardsSummary } from '@/interfaces/Rewards';

import { Offer } from './Offer';

export class Cart implements ICheckoutCart {
  uuid: string;
  customer?: ICheckoutCartCustomer;
  offer: ICheckoutCartOffer;
  custom_template_guid?: string;
  early_renewal_contract?: ICheckoutCartEarlyRenewalContract | null = null;
  estimated_renewal_ends_at?: string;
  estimated_renewal_starts_at?: string;
  suggested_offer: ICheckoutCartOffer | null = null;

  constructor(cart: ICheckoutCart|null, price?: { priceId: number, rewards: IRewardsSummary }) {
    Object.assign(this, {
      ...cart,
    });

    this.offer = new Offer(this.offer, this, price);

    if (this.suggested_offer) {
      this.suggested_offer = new Offer(this.suggested_offer, this, price);
    }
  }
}
